import React from 'react';
import _ from 'lodash';

import {
  QuoteSlice,
  type QuoteSliceProps,
} from '@ww-digital/web-palette-react/dist/components/Slice/QuoteSlice/QuoteSlice';

import { JSONLD } from '../../Metadata/JSONLD/JSONLD.tsx';

type JSONLDType = {
  '@type': 'Quote';
  name: 'card';
  author: {
    '@type': 'Organization';
    name: string;
    jobTitle?: string;
  };
};

type JSONLDArrayType = (JSONLDType | JSONLDType[])[];

interface QuoteSliceContainerProps {
  slice: QuoteSliceProps;
  daCategory: string;
}

export const QuoteSliceContainer = ({
  slice,
}: QuoteSliceContainerProps): JSX.Element => {
  const getJSONLD = () => {
    const { cards } = slice;
    if (!cards) return;

    const dataLD: JSONLDArrayType = [];
    cards.forEach((card) => {
      dataLD.push({
        '@type': 'Quote',
        name: 'card',
        author: {
          '@type': 'Organization',
          name: 'WeightWatchers',
        },
      });
    });

    const data = {
      '@context': 'https://schema.org',
      '@type': 'QuoteSlice',
      mainEntity: _.flattenDeep(dataLD),
    };

    return data;
  };

  const jsonLD = getJSONLD();

  return (
    <>
      <JSONLD key="jsonLd" content={jsonLD} addWebsiteName={false} />
      <QuoteSlice
        cards={slice.cards}
        button={slice.button}
        headerText={slice.headerText}
      />
    </>
  );
};
